import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, Paper } from '@mui/material';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getCustomerRegData } from '../../../Redux/action/Admin/CustomerAction';

import { adminMainUrl } from "../../../Config.jsx";

const Declaration = ({ customer_id }) => {
  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const dispatch = useDispatch();
  const [filePreview, setFilePreview] = useState(null);
  let initialValues = {

    creditPeriodDays: "",
    totalCreditLimit: "",
    declaration: null,
    cancelledCheque: "",

  }

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({


    }),
    onSubmit: (values, { resetForm }) => {

    }
  });


  useEffect(() => {

    if (customer_id) {
      dispatch(getCustomerRegData(customer_id))
    }
  }, []);

  let {
    loadingCustomerRegDataApi,
    CustomerRegDataError,
    CustomerRegData,
  } = useSelector(state => state?.CustomerReducer);

  useEffect(() => {
    if (CustomerRegData) {
      formik.setValues({
        creditPeriodDays: CustomerRegData?.creditPeriodDays ?? "",
        totalCreditLimit: CustomerRegData?.totalCreditLimit ?? "",
        declaration: CustomerRegData?.declaration ? true : false
      });

      // If there's a pre-existing cancelledCheque value, set the preview for it
      if (CustomerRegData?.cancelledCheque) {
        setFilePreview(`${adminMainUrl}/${CustomerRegData.cancelledCheque}`); // Set the image preview
      }
    }
  }, [CustomerRegData]);

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first file
    if (file) {
      formik.setFieldValue('cancelledCheque', file); // Update formik field value
      setFilePreview(URL.createObjectURL(file)); // Set the preview URL
    }
  };


  return (
    <>
      {/* <Toaster /> */}
      {

        <div id="section2" className="section2 customer_main_detail_form">
          <form onSubmit={formik.handleSubmit} className='p-4'>
            <div className='form-heading-bg'>
              <span>Declaration</span>

            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Credit Period Required by Party in Days
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='creditPeriodDays'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.creditPeriodDays}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Total Credit Limit Required by Party in
                    numeric figure (In Lacs)
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter name here"
                    name='totalCreditLimit'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.totalCreditLimit}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="basicpill-firstname-input" className="form-label">
                    Copy of Cancelled Cheque
                  </label>
                  <div className="custom-file-container">
                    <label className="custom-file-container__custom-file">
                      <i className="fa-solid fa-upload"></i> Upload Files
                      <input
                        type="file"
                        className="custom-file-container__custom-file__custom-file-input d-none"
                        name='cancelledCheque'
                        accept="image/*" // Ensure only image files are selected
                        onChange={handleFileChange}
                        onBlur={formik.handleBlur}
                      />
                      <span className="custom-file-container__custom-file__custom-file-control"></span>
                    </label>
                  </div>
                  <div className="help-block with-errors">
                    {formik.touched.cancelledCheque && formik.errors.cancelledCheque ? (
                      <div className="text-danger small">{formik.errors.cancelledCheque}</div>
                    ) : null}
                  </div>

                  {/* Image preview section */}
                  {filePreview && (
                    <div className="image-preview mt-2">
                      <img src={filePreview} alt="Preview" className="img-thumbnail" style={{ width: '200px', height: 'auto' }} />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <input id="checkbox" type="checkbox"
                  name='declaration'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.declaration}
                  checked={formik.values.declaration}
                /> I/We
                hereby declare that the particulars given
                herein above are true, correct and complete
                to the best of my/our knowledge and belief,
                the documents submitted in support of this
                Form, KYC are genuine and obtained legally
                from the respective issuing authority. In
                case of any change in any of the
                aforementioned particulars, I/we undertake
                to notify you in writing failing which the
                above particulars may be relied upon
                including all shipments/documents executed
                and tendered by the individual so authorized
                and mentioned above. I/we hereby authorize
                you to submit the above particulars to the
                customs and other regulatory authorities on
                my/our behalf as may be required in order to
                transport and customs clear my/our
                shipments.
              </div>
            </div>

          </form>
        </div >

      }
    </>

  )
}

export default Declaration